var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSignals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7.5C0 3.35786 3.35786 0 7.5 0C9.48912 0 11.3968 0.790176 12.8033 2.1967C14.2098 3.60322 15 5.51088 15 7.5C15 11.6421 11.6421 15 7.5 15C3.35786 15 0 11.6421 0 7.5ZM7.2975 10.2075L10.725 5.7075V5.685C10.8884 5.47064 10.9251 5.18537 10.8212 4.93664C10.7173 4.6879 10.4886 4.51351 10.2212 4.47914C9.95384 4.44476 9.68845 4.55564 9.525 4.77L6.69 8.52L5.4675 6.96C5.30271 6.74832 5.03751 6.64063 4.7718 6.67751C4.50608 6.71438 4.28022 6.8902 4.1793 7.13876C4.07837 7.38731 4.11771 7.67082 4.2825 7.8825L6.1125 10.215C6.25562 10.3961 6.47416 10.5012 6.705 10.5C6.93712 10.4994 7.15591 10.3914 7.2975 10.2075Z",
    fill: "url(#paint0_linear_2718_1975)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2718_1975",
    x1: -7.5,
    y1: 7.5,
    x2: 7.5,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#56F465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#56F465"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSignals);
export default __webpack_public_path__ + "static/media/ic_signals.6dbad00e693b0482c4159529425a1f01.svg";
export { ForwardRef as ReactComponent };